export default __webpack_public_path__ + "assets/icons/homemore.3529d227.svg";